module.exports = __webpack_public_path__ + "images/8c0985a3d2e9ff09ecd6f8b7971b9a14.png";